// @flow
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import React, { Fragment } from 'react';
import Slider from 'react-slick';
import cx from 'classnames';
import BannerCard from 'components/common/BannerCard';
import type { BannerItem } from 'store/modules/bannering';
import FakeBannerCard from 'components/common/FakeBannerCard';
import ArrowRight from 'components/common/Arrow/ArrowRight';
import ArrowLeft from 'components/common/Arrow/ArrowLeft';
import './BannerCardList.scss';

type Props = {
  banners?: ?(BannerItem[]),
  loading: boolean,
  prefetching: boolean,
  width?: number,
  hasEnded: boolean,
  oneColumn?: boolean,
  placeholderCount?: number,
  isTrending?: boolean,
};

const createArray = length => Array.from(Array(length).keys());

function PrevArrow(props) {
  const { className, onClick } = props;
  return (
    <ArrowLeft
      classname={className}
      click={onClick}
      background={'rgba(0,0,0,.15)'}
      width={25}
      height={25}
      color={'white'}
    />
  );
}

function NextArrow(props) {
  const { className, onClick } = props;

  return (
    <ArrowRight
      classname={className}
      click={onClick}
      background={'rgba(0,0,0,.15)'}
      width={25}
      height={25}
      color={'white'}
    />
  );
}

const BannerCardList = ({ banners, loading, prefetching, oneColumn, isTrending }: Props) => {
  const trendingCount = 1;
  if (loading) {
    return (
      <div className="BannerCardList">
        {createArray(trendingCount).map(num => (
          <FakeBannerCard key={num} oneColumn={oneColumn} />
        ))}
      </div>
    );
  }
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  const columnCount = 1;
  if (!banners) return null;
  const bannerList = banners.map(banner => (
    <BannerCard
      key={banner.id}
      id={banner.id}
      thumbnail={banner.thumbnail}
      title={banner.title}
      body={banner.meta && banner.meta.short_description}
      urlSlug={banner.url_slug}
      oneColumn={oneColumn}
    />
  ));

  const fakeBannerList = createArray(columnCount).map(num => (
    <FakeBannerCard key={num} oneColumn={oneColumn} />
  ));

  return (
    <Fragment>
      <div className={cx('BannerCardList', { 'is-trending': !isTrending })}>
        {isTrending ? (
          <Slider {...settings}>
            {bannerList && bannerList.length === 0 && (
              <div className="empty-list">아직 등록된 배너가 없습니다.</div>
            )}
            {bannerList}
            {prefetching && fakeBannerList}
          </Slider>
        ) : (
          <Fragment>
            {bannerList && bannerList.length === 0 && (
              <div className="empty-list">아직 등록된 배너가 없습니다.</div>
            )}
            {bannerList}
            {prefetching && fakeBannerList}
          </Fragment>
        )}
      </div>
    </Fragment>
  );
};

BannerCardList.defaultProps = {
  banners: [],
  oneColumn: false,
  width: 0,
  placeholderCount: 1,
};

export default BannerCardList;



// WEBPACK FOOTER //
// ./src/components/common/BannerCardList/BannerCardList.js